"use client";

import { UserEvents, trackEvent } from "@punchup/analytics";

import { SpecialRow } from "@/data/specials";
import StarsIcon from "./icons/StarsIcon";
import { WatchCTAButton } from "@/components/special";

export default function UnlockPill({
  className,
  special,
  comedianId,
}: {
  className: string;
  special: SpecialRow;
  comedianId: string;
}) {
  return (
    <button
      data-testid="watch-cta-button"
      className={className}
      onClick={() =>
        trackEvent(UserEvents.CLICKED_WATCH_FEATURED_SPECIAL, {
          ComedianId: comedianId,
          SpecialId: special.id,
        })
      }
    >
      <StarsIcon />
      <WatchCTAButton special={special} />
    </button>
  );
}
